import { combineReducers } from 'redux';

import accountId from './accountId';
import btfAccountId from './btfAccountId';
import cart from './cart';
import orders from './orders';
import accounts from './accounts';
import configUser from './configUser';
import contact from './contact';
import consentHub from './consentHub';
import license from './license';
import genericProperty from './genericProperty';
import downloads from './downloads';
import currency from './currency';
import products from './products';
import marketplace from './marketplace';
import creditCard from './creditCard';
import country from './country';
import product from './product';
import {
  AccountData,
  BTFData,
  ConfigUserData,
  MACAccountIdState,
  MACCartState,
  MACConsentHubState,
  MACContactState,
  MACLicenseState,
  OrdersData,
  MACGenericPropertyState,
  MACDownloadsState,
  MACCurrencyState,
  MACCreditCardState,
  MACCountryISOState,
  MACProductState,
  MACMarketplaceState,
} from '../models';

// TODO: Refactor naming to be more descriptive
export type MACState = {
  accountId: MACAccountIdState;
  btfAccountId: BTFData;
  cart: MACCartState;
  orders: OrdersData;
  accounts: AccountData;
  configUser: ConfigUserData;
  contact: MACContactState;
  consentHub: MACConsentHubState;
  license: MACLicenseState;
  genericProperty: MACGenericPropertyState;
  downloads: MACDownloadsState;
  currency: MACCurrencyState;
  products: MACProductState;
  creditCard: MACCreditCardState;
  country: MACCountryISOState;
  product: MACProductState;
  marketplace: MACMarketplaceState;
  productSourceDownload: MACDownloadsState;
  sourceDownloadURL: MACDownloadsState;
};

export default combineReducers({
  accountId,
  btfAccountId,
  cart,
  orders,
  accounts,
  configUser,
  contact,
  consentHub,
  license,
  genericProperty,
  downloads,
  currency,
  products,
  creditCard,
  country,
  product,
  marketplace,
});
